export default __webpack_public_path__ + "static/media/Group 625949.9aacc21a.png";